export default {"src":"/_next/static/media/AccurxLogoLong.a5c71f48.svg","height":58,"width":146,"blurWidth":0,"blurHeight":0};